import { Routes, Route } from "react-router-dom";


import Layout from "../components/Layout/Layout";
import PrivateRoute from "./PrivateRoute";

// Login
import Login from "../pages/login/Login";

// Recepção
import Recepcao from "../pages/recepcao/Recepcao";

// Cliente
import CadastroCliente from "../pages/cliente/CadastroCliente";
import Clientes from "../pages/cliente/Clientes";

// Home
import Principal from "../pages/home/Principal";
import Equipe from "../pages/home/Equipe";
import Parceiros from "../pages/home/Parceiros";
import Historia from "../pages/home/Historia";

// Atendimento
import FilaAtendimento from "../pages/atendimento/Atendimento";
import Atendimento from "../pages/atendimento/FichaAtendimento";
//import EntrevistaTrabalhista from "../pages/atendimento/Trabalhista";
//import Previdenciario from "../pages/atendimento/Previdenciario";
//import Civel from "../pages/atendimento/Civel";
//import Criminal from "../pages/atendimento/Criminal";
import Pendentes from "../pages/atendimento/Pendentes"
import Outros from "../pages/atendimento/Outros";
import Realizados from "../pages/atendimento/Realizados";

// Processos
import CadastrarProcesso from "../pages/processos/CadastrarProcesso";
import ConsultarProcessos from "../pages/processos/ConsultarProcessos";
import Peticionar from "../pages/processos/Peticionar";
import Andamento from "../pages/processos/Andamento";
import Conhecimento from "../pages/processos/Conhecimento";
import Execucao from "../pages/processos/Execucao";
import Conclusos from "../pages/processos/Conclusos";
import Dashboard from "../pages/Dashboard/Dashboard";
import EditorPeticao from "../pages/peticoes/EditorPeticao";

// Agenda
import LancarCompromisso from "../pages/agenda/LancarCompromisso";
import ConsultarAgenda from "../pages/agenda/ConsultarAgenda";

// Financeiro
import FinanceiroLancamento from "../pages/financeiro/FinanceiroLancamento";
import Financeiro from "../pages/financeiro/Financeiro";
import DashboardFinanceiro from "../pages/financeiro/DashboardFinanceiro";
import ValidarComprovante from "../pages/financeiro/ValidarComprovante";

// Administrativo
import CadastrarUsuario from "../pages/administrativo/CadastrarUsuario";
import GerenciarUsuarios from "../pages/administrativo/GerenciarUsuarios";
import GerenciamentoLogins from "../pages/administrativo/GerenciamentoLogins";
import Produtividade from "../pages/administrativo/Produtividade";
import GerenciamentoDocumentos from "../pages/administrativo/GerenciamentoDocumentos";

// Ajuda
import PainelPJE from "../pages/ajuda/PainelPJE";
import PainelOAB from "../pages/ajuda/PainelOAB";


const AppRoutes = () => {
  return (
    <Routes>
      {/* LOGIN */}
      <Route path="/login" element={<Login />} />

      <Route path="/comprovante/validarcomprovante/:id" element={<ValidarComprovante />} />

      {/* ROTAS PRIVADAS */}
      <Route element={<PrivateRoute><Layout /></PrivateRoute>}>

        {/* HOME */}
        <Route index element={<Principal />} />
        <Route path="home/equipe" element={<Equipe />} />
        <Route path="home/parceiros" element={<Parceiros />} />
        <Route path="home/historia" element={<Historia />} />

        {/* RECEPÇÃO */}
        <Route path="recepcao/recepcao" element={<Recepcao />} />

        {/* CLIENTE */}
        <Route path="/cliente/cadastro" element={<CadastroCliente />} />
        <Route path="/cliente/clientes" element={<Clientes />} />

        {/* ATENDIMENTO */}
        <Route path="atendimento/fila-atendimento" element={<FilaAtendimento />} />
        <Route path="atendimento/ficha-atendimento" element={<Atendimento />} />
        {/*<Route path="atendimento/trabalhista" element={<EntrevistaTrabalhista />} />
        <Route path="atendimento/previdenciario" element={<Previdenciario />} />
        <Route path="atendimento/civel" element={<Civel />} />
        <Route path="atendimento/criminal" element={<Criminal />} />*/}
        <Route path="atendimento/pendentes" element={<Pendentes />} />
        <Route path="atendimento/outros" element={<Outros />} />
        <Route path="atendimento/realizados" element={<Realizados />} />

        {/* PROCESSOS */}
        <Route path="processos/peticionar" element={<Peticionar />} />
        <Route path="processos/cadastrar" element={<CadastrarProcesso />} />
        <Route path="processos" element={<ConsultarProcessos />} />
        <Route path="processos/andamento" element={<Andamento />} />
        <Route path="processos/conhecimento" element={<Conhecimento />} />
        <Route path="processos/execucao" element={<Execucao />} />
        <Route path="processos/conclusos" element={<Conclusos />} />
        <Route path="processos/dashboard" element={<Dashboard />} />

        {/* EDITOR DE PETIÇÃO */}
        <Route path="editor-peticao" element={<EditorPeticao />} />
        <Route path="editor-peticao/:id" element={<EditorPeticao />} />

        {/* AGENDA */}
        <Route path="agenda/lancar" element={<LancarCompromisso />} />
        <Route path="agenda/consultar" element={<ConsultarAgenda />} />

        {/* FINANCEIRO */}
        <Route path="financeiro/lancar" element={<FinanceiroLancamento />} />
        <Route path="financeiro/financeiro" element={<Financeiro />} />
        <Route path="financeiro/dashboardfinanceiro" element={<DashboardFinanceiro />} />

        {/* ADMINISTRATIVO */}
        <Route path="administrativo/cadastro-usuario" element={<CadastrarUsuario />} />
        <Route path="administrativo/gerenciamento-usuarios" element={<GerenciarUsuarios />} />
        <Route path="administrativo/logins" element={<GerenciamentoLogins />} />
        <Route path="administrativo/produtividade" element={<Produtividade />} />
        <Route path="administrativo/documentos" element={<GerenciamentoDocumentos />} />


        {/* AJUDA */}
        <Route path="ajuda/pje" element={<PainelPJE />} />
        <Route path="ajuda/oab" element={<PainelOAB />} />

      </Route>
    </Routes>
  );
};

export default AppRoutes;